import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import  {  Getstates, fetchSubDistrict } from '../../../../Axios/ServiceApi';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
  // Checkbox,
  // Divider,
  FormControl,
  // FormControlLabel,
  FormHelperText,
  Grid,

  // InputAdornment,
  InputLabel,
  OutlinedInput,

  // TextField,
  // Typography,
  // useMediaQuery
} from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import useScriptRef from 'hooks/useScriptRef';
// import Upload from 'assets/images/Image upload-bro.svg';
// import Google from 'assets/images/icons/social-google.svg';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { Stack } from '@mui/system';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
// import Radio from '@mui/material/Radio';
// import RadioGroup from '@mui/material/RadioGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import FormLabel from '@mui/material/FormLabel';
// import { IconUserPlus } from '@tabler/icons';
// import { Image } from '@mui/icons-material';
// import { strengthColor, strengthIndicator } from 'utils/password-strength';

// assets
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { GetBankDetails, GetIfscDetails, postCdmData } from '../../../../Axios/LimitAccountRegistration';
import  {getProfileDetailsOnce}  from '../../../../Axios/Profile';
import CircularProgress from '@mui/material/CircularProgress';


// ===========================|| FIREBASE - REGISTER ||=========================== //

const CdmRegister = (props) => {
  const theme = useTheme();
  const scriptedRef = useScriptRef();




  const [stateList, setStateList] = useState(null)
  const[subDistrict,setSubDistrict] = useState(null)
  const [BankList, setBankList] = useState(null)
  const[userDetails, setUserDetails] = useState(null)
  const [ifscData, setIfscData] = useState(null)


  useEffect(() => {
    Getstates(setStateList)
    GetBankDetails(setBankList)
    getProfileDetailsOnce(setUserDetails)

  }, [])

  console.log('States ', stateList,userDetails);





  const handleIfscCheck=(ifsc,setFieldValue,validateForm)=>{
    GetIfscDetails(ifsc,setIfscData,setFieldValue,validateForm)
  }


  console.log("ifsc data", ifscData);






  const handleDistrictChange=(value,setFieldValue)=>{
    setFieldValue('district',value)
    fetchSubDistrict(value,setSubDistrict)
  }

  return (
    <>
    {/*  */}

      {/*  */}
      {
        userDetails?
        <Formik
        initialValues={{
          name:userDetails.first_name?userDetails.first_name: '',
          agent_code: sessionStorage.getItem('user_code')?sessionStorage.getItem('user_code'):'',
          mobile:userDetails.mobile_number?userDetails.mobile_number: "",
          address: "",
          bank_name: '',
          bank_branch:'',
          branch_code:"",
          ifsc_code:'',
          state:userDetails.retail_state?userDetails.retail_state:"",
          district:userDetails.retail_district?userDetails.retail_district:"",
          city:""
          // submit: null
        }}
        validationSchema={Yup.object().shape({
            name: Yup.string().max(255).required('Name is required'),
            mobile: Yup.string().required('Mobile number is required'),
            address:Yup.string().required("Address is required"),
            bank_branch:Yup.string().required("Bank Branch is required"),
            branch_code:Yup.string().required("Branch code is required"),
            agent_code: Yup.string().required('Agent Code is required'),
            bank_name: Yup.string().required('Bank Name is required'),
            state:Yup.string().required("State is required"),
            district:Yup.string().required("District is required"),
            city:Yup.string().required("City is required"),
            ifsc_code:Yup.string().required("IFSC Code is required")
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            if (scriptedRef.current) {
              console.log("hitt");
            }
          } catch (err) {
            console.error('error ', err);
            if (scriptedRef.current) {
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
            }
          }
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, isValid ,setFieldValue,validateForm}) => (
          <form noValidate onSubmit={handleSubmit}>
            <Stack direction={{ xs: 'column', xl: 'row', lg: 'row', md: 'row', sm: 'row' }}>
              {/* <MapModal change={change} setChange={setChange} open={open} handleClose={handleClose} /> */}
              <Grid item xs={12} sm={12}>
                <Grid container spacing={1}>



                  <Grid item xs={12} lg={6} md={6} sm={6}>
                    <FormControl fullWidth error={Boolean(touched.name && errors.name)} sx={{ ...theme.typography.customInput }}>
                      <InputLabel htmlFor="outlined-adornment-pincode-register">Name</InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-pincode-register"
                        type="text"
                        value={values.name}
                        name="name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        inputProps={{
                          readOnly:true
                        }}
                      />
                      {touched.name && errors.name && (
                        <FormHelperText error id="standard-weight-helper-text-pincode-register">
                          {errors.name}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} lg={6} md={6} sm={6}>
                    <FormControl fullWidth error={Boolean(touched.agent_code && errors.agent_code)} sx={{ ...theme.typography.customInput }}>
                      <InputLabel htmlFor="outlined-adornment-pincode-register">Agent Code</InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-pincode-register"
                        type="text"
                        value={values.agent_code}
                        name="agent_code"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        inputProps={{
                          readOnly:true
                        }}
                      />
                      {touched.agent_code && errors.agent_code && (
                        <FormHelperText error id="standard-weight-helper-text-pincode-register">
                          {errors.agent_code}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} lg={6} md={6} sm={6}>
                    <FormControl fullWidth error={Boolean(touched.mobile && errors.mobile)} sx={{ ...theme.typography.customInput }}>
                      <InputLabel htmlFor="outlined-adornment-pincode-register">Mobile number</InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-pincode-register"
                        type="text"
                        value={values.mobile}
                        name="mobile"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        inputProps={{
                          readOnly:true
                        }}
                      />
                      {touched.mobile && errors.mobile && (
                        <FormHelperText error id="standard-weight-helper-text-pincode-register">
                          {errors.mobile}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} lg={6} md={6} sm={6}>
                    <FormControl fullWidth error={Boolean(touched.branch_code && errors.branch_code)} sx={{ ...theme.typography.customInput }}>
                      <InputLabel htmlFor="outlined-adornment-pincode-register">IFSC Code</InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-pincode-register"
                        type="text"
                        value={values.ifsc_code}
                        name="ifsc_code"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        inputProps={{}}
                        endAdornment={
                          <Button
                            component="label"
                            sx={{ backgroundColor: '#A556B2', '&:hover': { backgroundColor: '#A556B2' } }}
                            variant="contained"
                            onClick={values.ifsc_code?()=>handleIfscCheck(values.ifsc_code,setFieldValue,validateForm):null}
                          >
                            Check
                          </Button>
                        }
                      />
                      {touched.ifsc_code && errors.ifsc_code && (
                        <FormHelperText error id="standard-weight-helper-text-pincode-register">
                          {errors.ifsc_code}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} lg={6} md={6} sm={6}>
                    <FormControl fullWidth error={Boolean(touched.address && errors.address)} sx={{ ...theme.typography.customInput }}>
                      <InputLabel htmlFor="outlined-adornment-pincode-register">Address</InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-pincode-register"
                        type="text"
                        disabled
                        value={values.address}
                        name="address"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        inputProps={{}}
                      />
                      {touched.address && errors.address && (
                        <FormHelperText error id="standard-weight-helper-text-pincode-register">
                          {errors.address}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} lg={6} md={6} sm={6}>
                    <FormControl disabled fullWidth error={Boolean(touched.bank && errors.bank)} sx={{ ...theme.typography.customInput }}>
                      <InputLabel htmlFor="outlined-adornment-pincode-register">Bank</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={values.bank_name}

                        label="Bank Name"
                        name='bank_name'
                        sx={{padding:'5px'}}
                        onChange={handleChange}
                      >
                        {
                          BankList&&BankList.map((item,index)=>{
                            return(
                              <MenuItem value={item} key={index}>{item}</MenuItem>
                            )
                          })
                        }

                      </Select>
                      {touched.bank && errors.bank && (
                        <FormHelperText error id="standard-weight-helper-text-pincode-register">
                          {errors.bank}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>



                  <Grid item xs={12} lg={6} md={6} sm={6}>
                    <FormControl fullWidth error={Boolean(touched.bank_branch && errors.bank_branch)} sx={{ ...theme.typography.customInput }}>
                      <InputLabel htmlFor="outlined-adornment-pincode-register">Branch Name</InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-pincode-register"
                        type="text"
                        disabled
                        value={values.bank_branch}
                        name="bank_branch"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        inputProps={{}}
                      />
                      {touched.bank_branch && errors.bank_branch && (
                        <FormHelperText error id="standard-weight-helper-text-pincode-register">
                          {errors.bank_branch}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>



                  <Grid item xs={12} lg={6} md={6} sm={6}>
                    <FormControl fullWidth error={Boolean(touched.branch_code && errors.branch_code)} sx={{ ...theme.typography.customInput }}>
                      <InputLabel htmlFor="outlined-adornment-pincode-register">Branch Code</InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-pincode-register"
                        type="text"
                        value={values.branch_code}
                        name="branch_code"
                        disabled
                        onBlur={handleBlur}
                        onChange={handleChange}
                        inputProps={{}}
                      />
                      {touched.branch_code && errors.branch_code && (
                        <FormHelperText error id="standard-weight-helper-text-pincode-register">
                          {errors.branch_code}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} lg={6} md={6} sm={6}>
                    <FormControl fullWidth error={Boolean(touched.state && errors.state)} sx={{ ...theme.typography.customInput }}>
                      <InputLabel id="demo-simple-select-label">State</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="outlined-simple-select"
                        value={values.state}
                        disabled
                        label="State"
                        name='state'
                        onChange={handleChange}
                        sx={{padding:0.7}}
                      >
                        {
                          stateList&&Object.keys(stateList).map((item)=>(

                            <MenuItem key={item} value={item}>{item}</MenuItem>
                          ))
                        }
                      </Select>
                      {touched.state && errors.state && (
                        <FormHelperText error id="standard-weight-helper-text-pincode-register">
                          {errors.state}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} lg={6} md={6} sm={6}>
                  <FormControl fullWidth error={Boolean(touched.district && errors.district)} sx={{ ...theme.typography.customInput }}>
                      <InputLabel id="demo-simple-select-label">Bank District</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="outlined-simple-select"
                        value={values.district}
                        disabled
                        label="Bank District"
                        name='district'
                        onChange={(e)=>handleDistrictChange(e.target.value,setFieldValue)}
                        sx={{padding:0.7}}
                      >
                        {
                          stateList&&Array.isArray(stateList[values.state])&&stateList[values.state].map((item)=>(

                            <MenuItem key={item} value={item}>{item}</MenuItem>
                          ))
                        }
                      </Select>
                      {touched.district && errors.district && (
                        <FormHelperText error id="standard-weight-helper-text-pincode-register">
                          {errors.district}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} lg={6} md={6} sm={6}>
                  <FormControl fullWidth error={Boolean(touched.city && errors.city)} sx={{ ...theme.typography.customInput }}>
                      <InputLabel id="demo-simple-select-label">City/Village</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="outlined-simple-select"
                        value={values.city}
                        onFocus={()=>handleDistrictChange(values.district,setFieldValue)}
                        label="City/Village"
                        name='city'
                        onChange={handleChange}
                        sx={{padding:0.7}}
                      >
                        {
                          subDistrict?
                          subDistrict&&Array.isArray(subDistrict[values.district])&&subDistrict[values.district].map((item)=>(

                            <MenuItem key={item} value={item}>{item}</MenuItem>
                          ))
                          :
                          <MenuItem key={1} value={1}>Loading...</MenuItem>
                        }
                      </Select>
                      {touched.district && errors.district && (
                        <FormHelperText error id="standard-weight-helper-text-pincode-register">
                          {errors.district}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  </Grid>


                {errors.submit && (
                  <Box sx={{ mt: 3 }}>
                    <FormHelperText error>{errors.submit}</FormHelperText>
                  </Box>
                )}
              </Grid>
            </Stack>
            <Grid container spacing={4}>

              <Grid item sm={6} xs={6}>
                <Box sx={{ mt: 2 }}>
                  <AnimateButton>
                    <Button
                      disableElevation
                      disabled={isSubmitting || !isValid}
                      fullWidth
                      size="large"
                      // type="submit"
                      variant="contained"
                      sx={{ backgroundColor: '#A556B2', color: '#fff', "&:hover": { backgroundColor: "#A556B2" } }}
                      onClick={()=>{!isSubmitting&&isValid?postCdmData(values,props.setAlertMessage,props.setErrOpen,props.setAlertType,props.setOpenLoader,setFieldValue)
                     :
                    null }}

                    >
                      {console.log(errors)}
                      Submit
                    </Button>
                  </AnimateButton>
                </Box>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
      :
<CircularProgress />
      }

      {/* image upload Dialog start */}
    </>
  );
};

export default CdmRegister;
